/**
 *
 * @param {Object} state
 * @param {Number} productId
 */
const setPreprendCartProductId = (state, productId) => {
  state.commit("SET_PREPREND_CART_PRODUCT_ID", productId);
};

/**
 *
 * @param {Object} { commit, rootState },
 */
const setPreprendCartRelatedProducts = ({ commit, rootState }, relatedProducts) => {
  if(typeof relatedProducts != 'undefined') {
    commit("SET_PREPREND_CART_RELATED_PRODUCT", relatedProducts);
  }
  else {
    commit("SET_PREPREND_CART_RELATED_PRODUCT", rootState.Product.appProduct.relatedProducts);
  }

};

/**
 *
 * @param {Object} { commit, rootState },
 */
const setPreprendCartInterventionSlots = ({ commit, rootState }, zeborne) => {
  commit("SET_PREPREND_CART_INTERVENTION_POSTAL_CODE", rootState.Delivery.delivery.postalCode);
  commit("SET_PREPREND_CART_INTERVENTION_AGENCE_ID", rootState.Delivery.delivery.agencyId);
  commit(
    "SET_PREPREND_CART_INTERVENTION_ADDITIONAL_SKU",
    rootState.Delivery.delivery.additionalCode,
  );
  commit("SET_PREPREND_CART_INTERVENTION_DATE", rootState.Delivery.delivery.deliveryDateStart);
  commit("SET_PREPREND_CART_INTERVENTION_SLOT", rootState.Delivery.delivery.slotId);

  commit("SET_PREPREND_CART_INTERVENTION_FAKE_SLOT", rootState.Delivery.delivery.fakeSlot);
  if(!zeborne) {
    commit("SET_PREPREND_CART_INTERVENTION_PRODUCT", rootState.Delivery.delivery.interventProductID);
  }

};

/**
 *
 * @param {Object} state
 * @param {Boolean} needCartCleaning
 */
const setPreprendCartNeedCartCleaning = (state, needCartCleaning) => {
  state.commit("SET_PREPREND_CART_NEED_CART_CLEANING", needCartCleaning);
};

/**
 *
 * @param {Object} state
 * @param {Boolean} standardDeliveryInCart
 */
const setPreprendCartStandardDeliveryInCart = (state, standardDeliveryInCart) => {
  state.commit("SET_PREPREND_CART_STANDARD_DELIVERY_IN_CART", standardDeliveryInCart);
};

/**
 *
 * @param {Object} state
 * @param {Boolean} currentSelectedDelivery
 */
const setPreprendCartCurrentSelectedDelivery = (state, currentSelectedDelivery) => {
  state.commit("SET_PREPREND_CART_CURRENT_SELECTED_DELIVERY", currentSelectedDelivery);
};


/**
 *
 * @param {Object} state
 * @param {Boolean} installationProductInCart
 */
const setPreprendCartInstallationProductInCart = (state, installationProductInCart) => {
  state.commit("SET_PREPREND_CART_INSTALLATION_PRODUCT_IN_CART", installationProductInCart);
};

/**
 *
 * @param {Object} state
 * @param {Boolean} deliveryOnly
 */
const setPreprendCartDeliveryOnly = (state, deliveryOnly) => {
  state.commit("SET_PREPREND_CART_DELIVERY_ONLY", deliveryOnly);
};

/**
 *
 * @param {Object} state
 * @param {Boolean} isExclusive
 */
const setPreprendCartIsExclusive = (state, isExclusive) => {
  state.commit("SET_PREPREND_CART_IS_EXCLUSIVE", isExclusive);
};
/**
 *
 * @param {Object} state
 * @param {Interger} quantity
 */
const setPreprendCartQuantity = (state, quantity) => {
  state.commit("SET_PREPREND_CART_QUANTITY", quantity);
};

/**
 *
 * @param {Object} state
 * @param {Number} additionalInfo
 */
const setAdditionalInfo = (state, additionalInfo) => {
  state.commit("SET_PREPREND_CART_ADDITIONAL_INFO", additionalInfo);
};

/**
 *
 * @param {Object} state
 * @param {Object} taxProfile
 */
const setTaxProfile = (state, taxProfile) => {
  state.commit("SET_TAX_PROFILE", taxProfile);
};

const setPreprendCartInterventionProduct = (state, interventionProductId) => {
    state.commit("SET_PREPREND_CART_INTERVENTION_PRODUCT", interventionProductId);
};

const setPreprendCartIsRenting = (state, isRenting) => {
    state.commit("SET_PREPREND_CART_IS_RENTING", isRenting);
};
const setPreprendCartIsFinancing = (state, isFinancing) => {
    state.commit("SET_PREPREND_CART_IS_FINANCING", isFinancing);
};

const setPreprendCartRentingNbMonths = (state, nbMonths) => {
    state.commit("SET_PREPREND_CART_NB_MONTHS", nbMonths);
};
const setPreprendCartFinancingNbMonths = (state, nbMonths) => {
    state.commit("SET_PREPREND_CART_FINANCING_NB_MONTHS", nbMonths);
};

export default {
  setPreprendCartProductId,
  setPreprendCartRelatedProducts,
  setPreprendCartCurrentSelectedDelivery,
  setPreprendCartInterventionSlots,
  setPreprendCartNeedCartCleaning,
  setTaxProfile,
  setPreprendCartStandardDeliveryInCart,
  setPreprendCartInstallationProductInCart,
  setPreprendCartDeliveryOnly,
  setPreprendCartIsExclusive,
  setPreprendCartQuantity,
  setAdditionalInfo,
  setPreprendCartInterventionProduct,
  setPreprendCartIsRenting,
  setPreprendCartIsFinancing,
  setPreprendCartRentingNbMonths,
  setPreprendCartFinancingNbMonths,
};
